import React from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { HitsStats } from 'searchkit'
import Translation from '../global/Translation'
import Modal from '../global/Modal'
import LegendOfLabelsContent from '../catalog/LegendOfLabelsContent'
import { TrackedSortingSelector } from '../catalog/results/TrackedSortingSelector'
import { isUsaOrCanada } from '../../store/centers/reducers'

const customHitStats = props => props.hitsCount

/**
 * Barra de resultados de la landing de campañas: contador, selector de orden y leyenda de etiquetas.
 * Es el equivalente del bloque `results__header__options` de ResultsV2, sin lo que no aplica a una
 * campaña (descarga a CSV, pestañas de piedra natural, avisos de outlet...).
 *
 * Tiene que renderizarse dentro de un <SearchkitProvider>.
 */
class PromotionResultsBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = { showLegendOfLabels: false, isExitingLegendOfLabels: false }
        this.modalLegendOfLabelsRef = React.createRef()
        this.handleModalLegendOfLabelsClick = this.handleModalLegendOfLabelsClick.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleModalLegendOfLabelsClick)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleModalLegendOfLabelsClick)
    }

    handleModalLegendOfLabelsClick(event) {
        // Cerrar al clicar fuera del contenido del modal (el ref apunta al .modal-body).
        if (this.modalLegendOfLabelsRef.current && !this.modalLegendOfLabelsRef.current.contains(event.target)) {
            this.handleCloseLegendOfLabels()
        }
    }

    handleOpenLegendOfLabels = () => {
        this.setState({ showLegendOfLabels: true })
    }

    handleCloseLegendOfLabels = () => {
        this.setState({ isExitingLegendOfLabels: true })

        setTimeout(() => {
            this.setState({ showLegendOfLabels: false, isExitingLegendOfLabels: false })
        }, 300) // Debe coincidir con la duración de la animación en CSS
    }

    render() {
        const { intl } = this.props

        return (
            <div className="results">
                <div className="results__header__options justify-content-start">
                    <div className="options__filters">
                        <div className="options__filters--count">
                            <span className="showing">
                                <Translation id="showing" defaultMessage="Showing" />
                            </span>
                            &nbsp;
                            <span className="count-text">
                                <HitsStats component={customHitStats} />
                            </span>
                            <span>
                                &nbsp;
                                <Translation id="results" defaultMessage="Results" />
                            </span>
                        </div>

                        <div className="catalog__sorting__selector">
                            <div className="order-by">
                                <span>
                                    <Translation id="order_by" defaultMessage="Order by" />
                                </span>
                            </div>
                            <div className="order-input">
                                <TrackedSortingSelector
                                    options={[
                                        // Sin `field` no se envía `sort`, y el backend mantiene el orden
                                        // en el que los materiales se guardaron en la campaña.
                                        {
                                            label: intl.formatMessage({ id: 'campaign' }),
                                            defaultOption: true
                                        },
                                        // Una campaña mezcla materiales normales y outlet, así que no hay
                                        // un "modo outlet" como en el catálogo: se ordena siempre por `stock`.
                                        {
                                            label: intl.formatMessage({ id: 'stock_high_to_low' }),
                                            field: 'stock',
                                            order: 'desc'
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'stock_low_to_high' }),
                                            field: 'stock',
                                            order: 'asc'
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'newest_arrivals' }),
                                            field: 'creationDate',
                                            order: 'desc'
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'oldest_materials' }),
                                            field: 'creationDate',
                                            order: 'asc'
                                        }
                                    ]}
                                />
                            </div>
                        </div>

                        <div>
                            <button onClick={this.handleOpenLegendOfLabels} className="btn-view-labels-info">
                                <Translation id="view_labels_info" defaultMessage="View labels info" />
                            </button>
                        </div>
                    </div>
                </div>

                {this.state.showLegendOfLabels && (
                    <Modal
                        title={<Translation id="legend_of_labels" defaultMessage="Legend of labels" />}
                        onClose={this.handleCloseLegendOfLabels}
                        showFooter={false}
                        customClass={`modal-legend-of-labels ${this.state.isExitingLegendOfLabels ? 'exit' : 'enter'}`}
                        ref={this.modalLegendOfLabelsRef}
                    >
                        <LegendOfLabelsContent isUsaOrCanada={this.props.isUsaOrCanada} />
                    </Modal>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isUsaOrCanada: isUsaOrCanada(state)
    }
}

export default injectIntl(connect(mapStateToProps)(PromotionResultsBar))
